/**
 * Eager WebSocket transport — pre-connects the gateway WS at notepad-toast-show
 * so the connection and gRPC handoff are ready before the notepad opens.
 *
 * Lifecycle:
 *   createEagerTransport()   — called when TOAST_VISIBLE, opens WS immediately
 *   consumeEagerTransport()  — called when notepad opens, hands off to TldrawAgentApp
 *   disposeEagerTransport()  — called when toast is dismissed without opening
 */

import { WebSocketTransport } from "./transport";

let _pending: WebSocketTransport | null = null;

export function createEagerTransport(): void {
  if (_pending) return;
  _pending = new WebSocketTransport();
}

export function consumeEagerTransport(): WebSocketTransport | null {
  const t = _pending;
  _pending = null;
  return t;
}

export function disposeEagerTransport(): void {
  _pending?.dispose();
  _pending = null;
}
